/**
 * src/lib/utils.ts
 * =============================================================================
 * Utilidades transversales de UI.
 *
 * `cn(...)` combina nombres de clase Tailwind de forma condicional y resuelve
 * conflictos (p.ej. si recibe "p-2" y "p-4" deja sólo "p-4"). Es el helper
 * estándar que usa shadcn/ui en todos sus componentes.
 *
 * Mantener este archivo MINIMAL. Cualquier utilidad que crezca más allá de
 * 1–2 líneas debe vivir en su propio fichero dentro de `src/lib/` o `src/services/`.
 * =============================================================================
 */

import { clsx, type ClassValue } from 'clsx'
import { twMerge } from 'tailwind-merge'

export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs))
}
